import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './_dropdown.scss';
import { useTranslation } from '../../../hooks';

const Dropdown = ({
  name,
  label,
  placeholder = 'Select options from dropdown',
  value,
  options = [],
  errorMessage,
  onChange = () => {},
  onBlur = () => {},
  disabled
}) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedValue, setSelectedValue] = useState(value || '');
  const inputRef = useRef(null);

  useEffect(() => {
    setSelectedValue(value || '');
  }, [value]);

  const compileClassNames = () => {
    let className = 'field field--dropdown';
    if (errorMessage) className += ' field--error';
    if (disabled) className += ' field--disabled';
    return className;
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setSearchTerm(newValue);
    setIsOpen(true);
    if (newValue === '') {
      onChange('');
      setSelectedValue('');
    }
  };

  const handleSelect = (selectedLabel) => {
    onChange(selectedLabel);
    setSelectedValue(selectedLabel);
    setSearchTerm('');
    setIsOpen(false);
    inputRef.current.blur();
  };

  const handleInputFocus = () => {
    setIsOpen(true);
    setSearchTerm('');
  };

  const handleInputBlur = (e) => {
    setTimeout(() => {
      setIsOpen(false);
      setSearchTerm('');
    }, 200);
    onBlur(e);
  };

  const filteredOptions = searchTerm
    ? options.filter(option =>
        i18n(option.label).toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options;

  return (
    <div className={compileClassNames()}>
      <label className='field__label' htmlFor={name}>
        {i18n(label)}
      </label>
      <div className='field__input-wrapper'>
        <input
          ref={inputRef}
          type="text"
          className="field__search"
          placeholder={i18n(placeholder)}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          value={isOpen ? searchTerm : selectedValue}
          onChange={handleInputChange}
          disabled={disabled}
        />
        {isOpen && (
          <ul className="field__dropdown-list">
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => (
                <li
                  key={option.value}
                  onMouseDown={(event) => {
                    event.preventDefault();
                    handleSelect(i18n(option.label));
                  }}
                  className={`field__dropdown-item ${i18n(option.label) === selectedValue ? 'selected' : ''}`}
                >
                  {i18n(option.label)}
                </li>
              ))
            ) : (
              <li className="field__dropdown-item no-options">{i18n('cp_no_options_available')}</li>
            )}
          </ul>
        )}
      </div>
      {errorMessage && (
        <small className='field__error-message'>{i18n(errorMessage)}</small>
      )}
    </div>
  );
};


Dropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
};

export default Dropdown;